import { createSelector } from '@ngrx/store';
import { SharedState } from './reducers';

export interface SharedFeatureState {
  shared: SharedState;
}

export const selectShared = (state: SharedFeatureState) => state.shared;
export const selectDiningAttributes = createSelector(selectShared, (state) => state.diningAttributes);
export const selectDiningLayout = createSelector(selectShared, (state) => state.diningLayout);
export const selectHeaderHeight = createSelector(selectShared, (state) => state.headerHeight);
